import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeMeioAnalise, loadMeioAnalises, changeStatus } from '~/store/modules/meio_analise/action';

const Create = () => {
  let history = useHistory();
  const [meioAnalise, setMeioAnalise] = useState(initialData);
  const { tipo_licenca_id } = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ MeioAnaliseReducer }) => MeioAnaliseReducer);

  // console.log('status_response MeioAnalise store: ',status_response);
  // console.log('errors MeioAnalise store: ',errors);
  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
  }, [errors]);


  useEffect(() => {
    if (status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadMeioAnalises({
            where:`tipo_licenca_id:${tipo_licenca_id}`
          }));
          dispatch(changeStatus(null));
        }
      );
    }
  }, [status_response, history, dispatch,tipo_licenca_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    // console.log('meioAnalise store: ',meioAnalise);
    if (!schema.isValidSync(meioAnalise)) {
      console.log('Error meioAnalise store: ',meioAnalise);
      let yup_errors = {};
      schema.validate(meioAnalise, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const meioAnalise_ = meioAnalise;
      meioAnalise_.tipo_licenca_id = parseInt(tipo_licenca_id);
      console.log('meioAnalise store: ',meioAnalise_);
      await dispatch(storeMeioAnalise(meioAnalise_));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Meio analise
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              meioAnalise={meioAnalise}
              schema={schema}
              setMeioAnalise={setMeioAnalise}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_meioAnalise"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;

